/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttributeDefinition } from './attributeDefinition';


export interface BusinessObjectFormatAttributeDefinitionsUpdateRequest { 
    /**
     * A list of attribute definitions that specify attributes which are required to be specified when registering Business Object                   Data against this format. Providing a list with no elements will remove all existing attributes for the business object format                
     */
    attributeDefinitions?: Array<AttributeDefinition>;
    /**
     * If true, enables Business Object Data Published Attributes Change Event Notification for all business object data registered                   under this business object format version                
     */
    enableBusinessObjectDataPublishedAttributesChangeEventNotification?: boolean;
}
